import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import UnitModal from './../../modals/UnitModal'

export default function FormLayout(props) {
    const { t } = useTranslation();
    const { formFields, formErrors, onSubmit, onFieldChange, onFieldBlur, handleReset, runtimeDataChange, isModal } = props;

    const [unitModalStatus, setUnitModal] = useState(false);
    const [filter, setFilter] = useState(true);

    useEffect(() => {
        if (props.search) {
            setFilter(false);
        }
    }, [props.search])

    const handleSubmit = (event) => {
        event.preventDefault();
        if (onSubmit) {
            onSubmit(event);
        }
    };

    const [selectedOption, setSelectedOption] = useState(null);

    const handleChange = (name) => (selectedOption) => {
        setSelectedOption(selectedOption);
        onFieldChange(name, selectedOption)
    };

    const onBlur = (name) => {
        if (selectedOption != null) {
            onFieldBlur(name, selectedOption.value)
        }
    }

    const openModal = (modalName) => {
        if (modalName === 'unitModal') {
            setUnitModal(true);
        }
    };

    const closeModal = (modalName, data = {}) => {
        if (modalName === 'unitModal') {
            setUnitModal(false);
            if (Object.keys(data).length > 0) {
                if (data.status === 'RESULT_OK') {
                    runtimeDataChange('unit');
                }
            }
        }
    };

    const applyFilter = () => {
        setFilter(!filter);
    }

    return (
        <>
            {props.search &&
                <div className='row'>
                    <div className='col-md-2 mb-2'>
                        <button className={`btn btn-sm ${!filter ? 'btn-primary' : 'btn-danger'}`} onClick={applyFilter}>{!filter ? t('apply_filter') : t('close_filter')}</button>
                    </div>
                </div>
            }
            {filter &&
                <div className={isModal ? "" : "card slideIn"}>
                    <div className={isModal ? "" : "card-body"}>
                        <form method='post' className="forms-sample" onSubmit={(e) => handleSubmit(e)}>
                            <div className='row'>
                                {formFields.map((field, index) => (
                                    <div key={`main-div-${index}`} className={field.className ? field.className : 'col-12'}>
                                        {(field.type === 'text' || field.type === 'number' || field.type === 'email' || field.type === 'date' || field.type === 'password') &&
                                            <div className='form-group'>
                                                <label htmlFor={field.id}>{t(field.label)}</label>
                                                {field.required && <span className='text-danger'> * </span>}
                                                <input
                                                    type={field.type}
                                                    id={field.id}
                                                    name={field.name}
                                                    placeholder={t(field.placeholder)}
                                                    value={field.value}
                                                    onChange={(e) => onFieldChange(field.name, e.target.value)}
                                                    onBlur={(e) => onFieldBlur(field.name, e.target.value)}
                                                    className={`form-control form-control-sm ${formErrors[field.name] != '' ? 'border border-danger' : ''}`}
                                                />
                                                {formErrors[field.name] && (
                                                    <p style={{ color: "red" }}>{t(formErrors[field.name])}</p>
                                                )}
                                            </div>
                                        }

                                        {field.type === 'textarea' &&
                                            <div className='form-group'>
                                                <label htmlFor={field.id}>{t(field.label)}</label>
                                                {field.required && <span className='text-danger'> * </span>}
                                                <textarea
                                                    id={field.id}
                                                    name={field.name}
                                                    placeholder={t(field.placeholder)}
                                                    value={field.value}
                                                    onChange={(e) => onFieldChange(field.name, e.target.value)}
                                                    onBlur={(e) => onFieldBlur(field.name, e.target.value)}
                                                    className={`form-control form-control-sm ${formErrors[field.name] ? 'border border-danger' : ''}`}
                                                />
                                                {formErrors[field.name] && (
                                                    <p style={{ color: "red" }}>{t(formErrors[field.name])}</p>
                                                )}
                                            </div>
                                        }
                                        {field.type === 'select' &&
                                            <div className='form-group'>
                                                <label>{t(field.label)}
                                                    {field.required && <span className='text-danger'> * </span>}
                                                    {field.btn &&
                                                        (field.btn.link ?
                                                            <Link className='text-primary' to={field.btn.link}> {field.btn.label}</Link> : <span style={{ cursor: "pointer" }} className='text-primary' onClick={(e) => openModal(field.btn.method)}>{field.btn.label}</span>
                                                        )
                                                    }
                                                </label>
                                                {field.select ? (
                                                    <Select
                                                        value={field.value}
                                                        onChange={handleChange(field.name)}
                                                        options={field.options}
                                                        isSearchable
                                                        onBlur={(e) => onBlur(field.name)}
                                                        placeholder="Select"
                                                    />
                                                ) : (
                                                    <select
                                                        id={field.id}
                                                        name={field.name}
                                                        value={field.value}
                                                        onChange={(e) => onFieldChange(field.name, e.target.value)}
                                                        onBlur={(e) => onFieldBlur(field.name, e.target.value)}
                                                        className={`form-control form-control-sm ${formErrors[field.name] ? 'border border-danger' : ''}`}
                                                    >
                                                        <option value="">Select</option>
                                                        {field.options.map((option, index) => (
                                                            <option key={`select-box-${index}`} value={option.value}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </select>)
                                                }
                                                {formErrors[field.name] && (
                                                    <p style={{ color: "red" }}>{t(formErrors[field.name])}</p>
                                                )}
                                            </div>
                                        }
                                        {field.type === 'radio' && (
                                            <div className='form-group'>
                                                <label htmlFor={field.id}>{t(field.label)}</label>
                                                {field.required && <span className='text-danger'> * </span>}
                                                {field.options.map((option, index) => (
                                                    <div key={`radio-box-${index}`} className={`form-check form-check-${option.class}`}>
                                                        <label htmlFor={`${field.name}-${index}`} className="form-check-label">
                                                            <input
                                                                type="radio"
                                                                id={`${field.name}-${index}`}
                                                                name={field.name}
                                                                value={option.value}
                                                                checked={field.value === option.value}
                                                                onChange={(e) => onFieldChange(field.name, e.target.value)}
                                                                onBlur={(e) => onFieldBlur(field.name, e.target.value)}
                                                                className="form-check-input"
                                                            />
                                                            <i className="input-helper"></i>
                                                            {t(option.label)}
                                                        </label>
                                                    </div>
                                                ))}
                                                {formErrors[field.name] && (
                                                    <p style={{ color: "red" }}>{t(formErrors[field.name])}</p>
                                                )}
                                            </div>
                                        )}
                                        {field.type === 'checkbox' && (
                                            <div className='form-group'>
                                                <label>{t(field.label)}</label>
                                                {field.required && <span className='text-danger'> * </span>}
                                                {field.options.map((option, index) => (
                                                    <div key={`check-box-${index}`} className="form-check form-check-primary">
                                                        <label htmlFor={`${field.name}-${index}`} className="form-check-label">
                                                            <input
                                                                type="checkbox"
                                                                id={`${field.name}-${index}`}
                                                                name={field.name}
                                                                value={option.value}
                                                                checked={field.value.includes(option.value)}
                                                                onChange={(e) => {
                                                                    let checkedValues = '';
                                                                    if (e.target.checked) {
                                                                        checkedValues = option.value;
                                                                    } else {
                                                                        checkedValues = '';
                                                                    }
                                                                    onFieldChange(field.name, checkedValues);
                                                                }}
                                                                onBlur={(e) => onFieldBlur(field.name, field.value)}
                                                                className="form-check-input"
                                                            />
                                                            {option.label}<i className="input-helper"></i>
                                                        </label>
                                                    </div>
                                                ))}
                                                {formErrors[field.name] && (
                                                    <p style={{ color: "red" }}>{t(formErrors[field.name])}</p>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                ))}
                                {
                                    props.search && <div className='col-md-2 mt-1'>
                                        <br />
                                        <button type="submit" className="btn btn-primary mr-2 auto_click">{t('search')}</button>
                                    </div>
                                }
                            </div>
                            {!props.search &&
                                <div className='text-center'>
                                    <button type="submit" className="btn btn-primary mr-2 auto_click">{t('submit')}</button>
                                    {isModal ? '' : <button type="reset" className="btn btn-secondary" onClick={handleReset}>
                                        {t('reset')}
                                    </button>
                                    }
                                </div>
                            }
                        </form>
                    </div>
                    <UnitModal show={unitModalStatus} handleClose={closeModal} />
                </div>
            }
           
        </>
    )
}
